// UserIcons.tsx
import { SvgIcon, SvgIconProps } from "@mui/material";

// Industries & Disciplines Icon
export const GlitterIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 3600 3600">
      <path
        d="m2628 108s-87.047 418.64-230.2 561.78c-143.16 143.16-561.78 230.2-561.78 230.2s418.64 87.047 561.78 230.2c143.16 143.16 230.2 561.78 230.2 561.78s87.047-418.64 230.2-561.78c143.16-143.16 561.78-230.2 561.78-230.2s-418.64-87.047-561.78-230.2c-143.16-143.16-230.2-561.78-230.2-561.78zm-1800 432s-71.297 342.56-188.3 459.72c-117.14 117.14-459.72 188.3-459.72 188.3s342.56 71.297 459.72 188.3c117.14 117.14 188.3 459.72 188.3 459.72s71.297-342.56 188.3-459.72c117.14-117.14 459.72-188.3 459.72-188.3s-342.56-71.297-459.72-188.3c-117-117.14-188.3-459.72-188.3-459.72zm1008 1368s-83.109 399.67-219.8 536.22c-136.55 136.55-536.22 219.8-536.22 219.8s399.67 83.109 536.22 219.8c136.55 136.55 219.8 536.22 219.8 536.22s83.25-399.67 219.8-536.22 536.22-219.8 536.22-219.8-399.67-83.109-536.22-219.8c-136.55-136.55-219.8-536.22-219.8-536.22z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
